import { PlusCircle, XCircle } from 'lucide-react';

import {
  Badge,
  Button,
  Checkbox,
  Icon,
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarSeparator,
  MenubarTrigger,
  Separator,
  Text,
} from '@/_components';

import type { DataTableFacetedFilterProps } from './use-faceted-filter';
import { useFacetedFilter } from './use-faceted-filter';

export function DataTableFacetedFilter(props: DataTableFacetedFilterProps) {
  const { title, options } = props;
  const { selectedValues, setSelected } = useFacetedFilter(props);

  return (
    <Menubar tabIndex={-1}>
      <MenubarMenu>
        <MenubarTrigger>
          <Button
            tag="div"
            as="outline"
            size="sm"
            className="border-dashed px-2.5 py-1.5"
            iconLeft={PlusCircle}
            iconClassName="size-4"
          >
            {title}
            {selectedValues?.size > 0 && (
              <>
                <Separator orientation="vertical" className="mx-2 h-4" />
                <Badge size="sm" className="py-0.5 lg:hidden">
                  {selectedValues.size}
                </Badge>
                <div className="hidden space-x-1 lg:flex">
                  {selectedValues.size > 2 ? (
                    <Badge size="sm" className="py-0.5">
                      {selectedValues.size} selected
                    </Badge>
                  ) : (
                    options
                      .filter((option) => selectedValues.has(option.value))
                      .map((option) => (
                        <Badge size="sm" className="py-0.5" key={option.value}>
                          {option.name}
                        </Badge>
                      ))
                  )}
                </div>
              </>
            )}
          </Button>
        </MenubarTrigger>
        <MenubarContent>
          <Text as="small" className="text-c-card-foreground px-2 pt-0 pb-0 font-bold">
            Filter
          </Text>
          <MenubarSeparator className="my-2" />

          {options.map((option) => {
            const isSelected = selectedValues.has(option.value);

            if (option.value === '') return null;
            return (
              <MenubarItem
                key={option.value}
                onClick={() => {
                  if (isSelected) {
                    selectedValues.delete(option.value);
                  } else {
                    selectedValues.add(option.value);
                  }
                  const filterValues = Array.from(selectedValues);
                  setSelected(filterValues);
                }}
              >
                <Checkbox checked={isSelected} onChange={() => {}} />
                <span>{option.name}</span>
              </MenubarItem>
            );
          })}

          {selectedValues.size > 0 && (
            <>
              <MenubarSeparator className="my-2" />
              <MenubarItem onClick={() => setSelected([])} className="flex items-center gap-x-3">
                <Icon icon={XCircle} />
                <span>Clear all</span>
              </MenubarItem>
            </>
          )}
        </MenubarContent>
      </MenubarMenu>
    </Menubar>
  );
}
